export default __webpack_public_path__ + "ab06582d00cf793daf965a0cd8adf196.svg";